module.exports = __webpack_public_path__ + "img/vodacom-basketball-background-desktop.146e2162.png";